import React from 'react';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import DateRanges from './date-ranges';
import DateUtils from '../../../../utils/date-utils';
import { propOr } from 'ramda';

const SingleSection = ({
  index,
  ContentNode,
  contractingPeriod,
  takenDateRanges,
  removeOneSeasonSet,
  contentActions,
  dateRangeActions,
  seasons,
  datesEditable,
  correctSeasonName,
  useCorrectSeason,
  ...contentData,
}) => {
  const {
    onChangeDate,
    removeADateRange,
    addADateRange,
  } = dateRangeActions;
  const dateRanges = propOr([{}], 'dateRanges', contentData);
  const seasonName = datesEditable ? '' : DateUtils.getSeasonNameIfMatch(seasons, dateRanges);
  // const seasonName = seasons[index] ? seasons[index].seasonName : '';
  return (
    <div
      style={{ borderBottom: '1px solid #ededed', borderTop: '1px solid #ededed', minHeight: '100px' }}
    >
      <div style={{ height: '32px', backgroundColor: '#fafafa', borderBottom: '1px solid #ededed', lineHeight: '32px' }}>
        <div style={{ marginLeft: '32px', display: 'inline-block' }}>
          <span>{seasonName}</span>
          {
            !seasonName && correctSeasonName ? (
              <div style={{ color: '#f44336' }}>
                The date ranges below doesn't match {correctSeasonName}.
                <div
                  onClick={useCorrectSeason}
                  style={{ display: 'inline-block', marginLeft: '12px', color: '#00BCD4', cursor: 'pointer' }}
                >Correct Date Ranges</div>
              </div>
            ) : <div/>
          }
        </div>
        <div
          style={{
            display: datesEditable ? 'inline-block' : 'none',
            marginRight: '64px',
            lineHeight: '32px',
            verticalAlign: 'middle',
            color: '#ff4081',
            cursor: 'pointer',
            float: 'right',
          }}
          onClick={() => removeOneSeasonSet(index)}
        >
          DELETE
        </div>
      </div>
      <TwoColumnRow
        outerContainerStyle={{ overflow: 'hidden', minHeight: '52px', paddingTop: '4px', paddingLeft: '32px', marginBottom: '0' }}
        leftColumnStyle={{ width: datesEditable ? '40%' : '20%', fontSize: '12px', position: 'relative', top: '12px', paddingBottom: datesEditable ? '0px' : '24px' }}
        rightColumnStyle={{ width: datesEditable ? '60%' : '80%' }}
        leftColumnContent={
          <DateRanges
            dateRanges={dateRanges}
            datesNotEditable={!datesEditable}
            contractingPeriod={contractingPeriod}
            takenDateRanges={takenDateRanges}
            onChangeDate={onChangeDate(index)}
            removeADateRange={removeADateRange(index)}
            addADateRange={addADateRange(index)}
          />
        }
        rightColumnContent={<ContentNode index={index} {...contentData} {...contentActions} />}
      />
    </div>
  );
};

export default SingleSection;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/seasonal-sections/single-section.jsx